exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cockpit-view .container{width:auto}.cockpit-view .container .cockpit-form{margin-left:50px}.cockpit-view .container .cockpit-charts{margin-top:50px}.cockpit-view .datum-berich-btn{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/cockpit/cockpit.module.scss
// module id = v/cP
// module chunks = 0